export interface IIdleDeadline {
    didTimeout: boolean;
    timeRemaining(): number;
}

export function requestIdleCallbackPolyfill(cb: (deadline: IIdleDeadline) => void): number {
    const start = Date.now();

    return window.setTimeout(() => {
        cb({
            didTimeout: false,
            timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
        });
    }, 1);
}

window.requestIdleCallback = window.requestIdleCallback || requestIdleCallbackPolyfill;

function idleReduce<T, R>(
    array: T[],
    reducer: (acc: R, item: T, index: number, array: T[]) => R,
    initialValue: R,
): Promise<R> {
    return new Promise((resolve) => {
        let index = 0;
        let acc = initialValue;

        function processChunk(deadline: IIdleDeadline) {
            while (index < array.length && deadline.timeRemaining() > 0) {
                acc = reducer(acc, array[index], index, array);
                index++;
            }

            if (index < array.length) {
                requestIdleCallback(processChunk);
            } else {
                resolve(acc);
            }
        }

        requestIdleCallback(processChunk);
    });
}

export default idleReduce;
